import { render } from "./AppFooter.vue?vue&type=template&id=33f3b82a&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=33f3b82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f3b82a"]])

export default __exports__